define([
    'text!index2021-cooperate/component/cooperate-item.html',
    'cooperate/component/item-project',
    'cooperate/component/item-design',
    'cooperate/component/item-grocery',
    'cooperate/component/item-marketing',
    'cooperate/component/item-gallery',
    'web/common/utils',

    'css!index2021-cooperate/component/cooperate-item.css'
], function(
    tpl,
    ItemProject,
    ItemDesign,
    ItemGrocery,
    ItemMarketing,
    ItemGallery,
    Utils
){
    return {
        template: tpl,
        components: {
            ItemProject: ItemProject,
            ItemDesign: ItemDesign,
            ItemGrocery: ItemGrocery,
            ItemMarketing: ItemMarketing,
            ItemGallery: ItemGallery
        },
        data: function(){
            return {
                isOpen: false
            };
        },
        props: {
            item: {
                type: Object
            }
        },
        computed: {
            currentComponent: function(){
                switch(this.item.type){
                    case 1:
                        return 'ItemProject';
                    case 2:
                        return 'ItemDesign';
                    case 3:
                        return 'ItemGrocery';
                    case 4:
                        return 'ItemMarketing';
                    case 5:
                        return 'ItemGallery';
                    default:
                        return '';
                }
            },
            activeType: function(){
                var type = this.$route.query.type;
                if (!type) return -1;
                return parseInt(type);
            }
        },
        watch: {
            isOpen: 'onToggle'
        },
        methods: {
            toggle: function(){
                this.isOpen = !this.isOpen;
            },
            init: function(){
                // if (this.activeType && this.activeType === this.item.type){
                //     this.isOpen = true;
                // }
            },
            onToggle: function(){
                if (this.isOpen) {
                    this.$nextTick(function(){
                        Utils.scrollIntoView(this.$el);
                    });
                }
            }
        },
        created: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/cooperate-item.js
// module id = 203
// module chunks = 0